var exports = {
  "Zd": "AddFriendForm.module__form___aFR1Z1",
  "kL": "AddFriendForm.module__container___aFR1Z1",
  "QX": "AddFriendForm.module__containerDesktop___aFR1Z1",
  "hF": "AddFriendForm.module__input___aFR1Z1",
  "Rq": "AddFriendForm.module__inputDesktop___aFR1Z1",
  "Xu": "AddFriendForm.module__inputError___aFR1Z1",
  "x6": "AddFriendForm.module__button___aFR1Z1",
  "oR": "AddFriendForm.module__inlineButton___aFR1Z1",
  "gJ": "AddFriendForm.module__errorMessage___aFR1Z1",
  "Jl": "AddFriendForm.module__successMessage___aFR1Z1",
};

module.exports = exports;
